import { Skeleton } from '@mantine/core'

/**
 * 事件卡片加载占位：与 redesigned compact 卡片同形（圆角 12px），
 * 固定 min-height 避免骨架→内容的高度跳变。cdc-market 的 Skeleton 自带
 * shimmer（`--bg-surface-secondary` 底），不另做动效。
 */
export function EventCardSkeleton() {
  return <Skeleton mih={286} style={{ borderRadius: 12 }} aria-hidden />
}
